/* cspell: disable */

import { HAS_WINDOW } from './window'

const UA = HAS_WINDOW ? navigator.userAgent : ''

export const playwright = HAS_WINDOW ? (navigator.webdriver ?? false) : false

// At build time this is replaced with a constant `null` and removed by dead code elimination
export const vitest = import.meta.env?.VITEST === 'true'

export const mac = /macintosh/i.test(UA)
export const iOS = /ipad|iphone|ipod/i.test(UA)
export const apple = mac || iOS
export const android = /android/i.test(UA)

export const firefox = /firefox|iceweasel|fxios/i.test(UA)
export const chrome = !firefox && /chrome|crios|crmo/i.test(UA)
export const safari = apple && !firefox && !chrome && /safari|applewebkit/i.test(UA)
